import FragmentPage from '../core/FragmentPage';

export default class LegalPage extends FragmentPage {
  constructor(meta) {
    super('legal', meta);
  }
}
